import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["endSlot", "flush", "middleSlot", "responsive", "startSlot"];
import { AbstractToolbar } from '../AbstractToolbar/AbstractToolbar';
import { DATA_TRANSITIONAL_COMPONENT_ATTRIBUTE } from '../../constants';
import { FilterBarContext } from './FilterBarContext';
import { TFlex } from '../TFlex';
import { ControlProvider } from '../Link/ControlContext';
import { jsx as _jsx } from "react/jsx-runtime";
const CustomEnd = ({
  children,
  __distributeEvenly
}) => {
  return /*#__PURE__*/_jsx(TFlex, Object.assign({
    columnGap: "200",
    justifyContent: "end",
    alignItems: "center",
    flexShrink: 0,
    flexGrow: 0,
    inlineSize: 'auto',
    minInlineSize: "auto"
  }, __distributeEvenly && {
    flexShrink: 1,
    flexGrow: 1,
    flexBasis: '0%'
  }, {
    children: children
  }));
};
export const FilterBar = _ref => {
  let {
      endSlot,
      flush = false,
      middleSlot,
      responsive = true,
      startSlot
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsx(FilterBarContext.Provider, {
    value: {
      isFilterBar: true
    },
    children: /*#__PURE__*/_jsx(ControlProvider, {
      isControl: true,
      children: /*#__PURE__*/_jsx(AbstractToolbar, Object.assign({
        backgroundColor: "fill-transparent-default",
        endSlot: endSlot,
        End: CustomEnd,
        middleSlot: middleSlot,
        responsive: responsive,
        startSlot: startSlot,
        marginBlock: flush ? '0' : '500'
      }, rest, {
        [DATA_TRANSITIONAL_COMPONENT_ATTRIBUTE]: 'FilterBar'
      }))
    })
  });
};
FilterBar.displayName = 'FilterBar';